import { Box, Text, Image } from "@chakra-ui/react";

import Menubar from "../components/Menubar";
import ippojitsumugai from "../assets/ippojitsumugai.png";
import { ACCENT_1_COLOR } from "../constants/color";
import background from "../assets/bg.jpg"
import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet-async";


export default function MugaiRyu() {
  const {t} = useTranslation();
  const schemaMarkup = {
    "@context": "https://schema.org",
    "@type": "Article",
    "headline": "Sejarah dan Perkembangan Mugai Ryu Iaido",
    "description": "Penjelasan mendalam tentang Mugai Ryu, aliran pedang samurai klasik (Koryu) yang didirikan pada tahun 1693.",
    "url": "https://mugairyu-indonesia.com/mugai-ryu",
    "publisher": {
      "@type": "Organization",
      "name": "Mugai Ryu Indonesia",
      "logo": "https://mugairyu-indonesia.com/logo.png"
    }
  };
  return (
    <Box
      display={"flex"}
      width={"100vw"}
      pb={"24px"} 
      background={`transparent url(${background})`}
      bgRepeat={"repeat"}
    >
      <Helmet>
        <title>{t("aboutUsTitle")}</title>
        <meta name="description" content={t("aboutUsDesc")} />
        <link rel="canonical" href="https://mugairyu-indonesia.com/mugai-ryu" />
        
        <script type="application/ld+json">
          {JSON.stringify(schemaMarkup)}
        </script>
      </Helmet>
      <Box
        width={"100vw"}
        height={"auto"}
      >
        <Menubar />
        <Box
          width={"100vw"}
          px={{ base: "5vw", lg: "20vw" }}
          display={"flex"}
          flexDir={"column"}
          textAlign={"left"}
          mt={"18px"}
        >
          <Text textColor={ACCENT_1_COLOR} fontSize={"30px"}>
            Mugai Ryu
          </Text>
          <Text
            textColor={"#765946"}
            fontSize={"24px"}
            mb={"24px"}
            className="yuji-syuku-regular"
            style={{lineHeight: "24px"}}
          >
            無外流
          </Text>
          <Text mb={"18px"}>
            {t("mugaiRyu1")}
          </Text>

          <Text mb={"18px"}>
            {t("mugaiRyu2")}
          </Text>

          <Text mb={"18px"}>
            {t("mugaiRyu3")}
          </Text>

          <Text mb={"18px"}>
            {t("mugaiRyu4")}
          </Text>
          <Text fontStyle={"italic"} mb={"12px"}>
            {t("mugaiRyu5")} <br /> {t("mugaiRyu6")} <br /> {t("mugaiRyu7")}{" "}
            <br /> {t("mugaiRyu8")}
          </Text>

          <Image src={ippojitsumugai} w={"100%"} mb={"24px"}></Image>

          <Text fontStyle={"italic"}>
            {t("mugaiRyu9")} <br />
            {t("mugaiRyu10")} <br />
            {t("mugaiRyu11")} <br />
            {t("mugaiRyu12")}
          </Text>
        </Box>
      </Box>
    </Box>
  );
}
